import Vue from 'vue'

import EmptyLayout from '@/app/layouts/empty-layout.vue'
import SidebarLayout from '@/app/layouts/sidebar-layout'

Vue.component('empty-layout', EmptyLayout)
Vue.component('sidebar-layout', SidebarLayout)
